import service from "@/store/services/templates-mails-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  templateMail: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, templateMail) => {
    state.templateMail = templateMail;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((templateMail) => {
      commit("SET_RESOURCE", templateMail);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((templateMail) => {
      commit("SET_RESOURCE", templateMail);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((templateMail) => {
      commit("SET_RESOURCE", templateMail);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  defaultTemplate({ commit, dispatch }, params) {
    return service.defaultTemplate(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  templatesMail: (state) => state.templateMail,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((templateMail) => ({
      id: templateMail.id,
      title: templateMail.title,
    }));
  },
};

const templatesMails = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default templatesMails;
